import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-600 to-teal-700 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">F</span>
              </div>
              <div>
                <h2 className="text-xl font-bold">Fenix Partnership Ltd</h2>
                <p className="text-sm text-gray-400">Creating Beautiful Spaces for Life's Most Important Moments</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              We are owners and developers of cemeteries and memorial gardens across the UK, 
              dedicated to creating beautifully landscaped spaces that celebrate life and provide 
              comfort to families.
            </p>
            <p className="text-sm text-gray-400 italic">
              "Where memory meets tranquility, and life is celebrated with dignity."
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-emerald-400 transition-colors">Home</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-emerald-400 transition-colors">Services</Link></li>
              <li><Link to="/masterplan" className="text-gray-300 hover:text-emerald-400 transition-colors">The Masterplan</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-emerald-400 transition-colors">About</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-emerald-400 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone size={16} className="text-emerald-400" />
                <span className="text-gray-300">020 3576 3018</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail size={16} className="text-emerald-400" />
                <a href="mailto:info@fenixpartnership.co.uk" className="text-gray-300 hover:text-emerald-400 transition-colors">
                  info@fenixpartnership.co.uk
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin size={16} className="text-emerald-400 mt-1" />
                <span className="text-gray-300 text-sm">
                  UK-wide service with strategic locations
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 Fenix Partnership Ltd. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/investment" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
              Investment Opportunities
            </Link>
            <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors text-sm">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;